const oscillators = {
  C4: null,
  "C4#": null,
  D4: null,
  E4b: null,
  E4: null,
  F4: null,
  "F4#": null,
  G4: null,
  "G4#": null,
  A4: null,
  B4b: null,
  B4: null,
  C5: null,
  "C5#": null,
  D5: null,
  E5b: null,
  E5: null,
  F5: null,
  "F5#": null,
  G5: null,
  "G5#": null,
  A5: null,
  B5b: null,
  B5: null
};

const frequencies = {
  C4: 261.626,
  "C4#": 277.183,
  D4: 293.665,
  E4b: 311.127,
  E4: 329.628,
  F4: 349.228,
  "F4#": 369.994,
  G4: 391.995,
  "G4#": 415.305,
  A4: 440.0,
  B4b: 466.164,
  B4: 493.883,
  C5: 523.251,
  "C5#": 554.365,
  D5: 587.33,
  E5b: 622.254,
  E5: 659.255,
  F5: 698.456,
  "F5#": 739.989,
  G5: 783.991,
  "G5#": 830.609,
  A5: 880.0,
  B5b: 932.328,
  B5: 987.767
};

const makeBass = context => {
  const filter = context.createBiquadFilter();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sine";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "square";
  filter.type = "lowpass";
  filter.frequency.value = 500;

  const gain = context.createGain();
  gain.gain.setValueAtTime(0.3, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.01, context.currentTime + 0.5);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(filter);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note] / 8;
      oscillator2.frequency.value = frequencies[note] / 8;
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makePad = context => {
  const filter = context.createBiquadFilter();
  const pan = context.createStereoPanner();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sawtooth";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "square";
  filter.type = "lowpass";
  filter.frequency.value = 3000;
  pan.pan.value = -0.2;
  pan.connect(filter);

  const gain = context.createGain();
  gain.value = 0.001;
  gain.gain.setValueAtTime(0.001, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.15, context.currentTime + 0.3);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(pan);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note] / 2;
      oscillator2.frequency.value = frequencies[note] / 2;
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makeLead = context => {
  const filter = context.createBiquadFilter();
  const pan = context.createStereoPanner();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sawtooth";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "triangle";
  filter.type = "lowpass";
  filter.frequency.value = 600;
  pan.pan.value = 0.4;
  pan.connect(filter);

  const gain = context.createGain();
  gain.value = 0.01;
  gain.gain.setValueAtTime(0.005, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.2, context.currentTime + 0.3);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(pan);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note];
      oscillator2.frequency.value = frequencies[note];
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makeDarkBass = context => {
  const filter = context.createBiquadFilter();
  const pan = context.createStereoPanner();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sawtooth";
  oscillator1.detune.value = 100;
  const oscillator2 = context.createOscillator();
  oscillator2.detune.value = -400;
  oscillator2.type = "sawtooth";
  filter.type = "lowpass";
  filter.frequency.value = 1000;
  pan.pan.value = 0.4;
  pan.connect(filter);

  const gain = context.createGain();
  gain.value = 0.01;
  gain.gain.setValueAtTime(0.06, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.3, context.currentTime + 0.3);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(pan);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note] / 4;
      oscillator2.frequency.value = frequencies[note] / 4;
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makeDrops = context => {
  const filter = context.createBiquadFilter();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "triangle";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "sine";
  filter.type = "lowpass";
  filter.frequency.value = 500;

  const gain = context.createGain();
  gain.gain.setValueAtTime(0.3, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 0.1);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(filter);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note];
      oscillator2.frequency.value = frequencies[note];
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillator1.stop(context.currentTime + 0.2);
      oscillator2.stop(context.currentTime + 0.2);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makePiano = context => {
  const filter = context.createBiquadFilter();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "triangle";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "sawtooth";
  filter.type = "lowpass";
  filter.frequency.value = 800;

  const gain = context.createGain();
  gain.gain.setValueAtTime(0.3, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 0.5);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(filter);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note];
      oscillator2.frequency.value = frequencies[note];
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillator1.stop(context.currentTime + 0.5);
      oscillator2.stop(context.currentTime + 0.5);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makeMosquito = context => {
  const filter = context.createBiquadFilter();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sawtooth";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "sawtooth";
  oscillator2.detune.value = 400;
  filter.type = "lowpass";
  filter.frequency.value = 8000;

  const gain = context.createGain();
  gain.gain.setValueAtTime(0.001, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.3, context.currentTime + 0.5);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(filter);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note];
      oscillator2.frequency.value = frequencies[note];
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillator1.stop(context.currentTime + 0.5);
      oscillator2.stop(context.currentTime + 0.5);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

const makeElectronicGhost = context => {
  const filter = context.createBiquadFilter();
  const oscillator1 = context.createOscillator();
  oscillator1.type = "sawtooth";
  const oscillator2 = context.createOscillator();
  oscillator2.type = "square";
  oscillator2.detune.value = -800;
  filter.type = "lowpass";
  filter.frequency.value = 1800;

  const gain = context.createGain();
  gain.gain.setValueAtTime(0.01, context.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.2, context.currentTime + 0.3);

  oscillator1.connect(gain);
  oscillator2.connect(gain);

  gain.connect(filter);

  return note => {
    if (!oscillators[note] && frequencies[note]) {
      oscillator1.frequency.value = frequencies[note];
      oscillator2.frequency.value = frequencies[note];
      oscillator1.start(context.currentTime);
      oscillator2.start(context.currentTime);
      oscillators[note] = [oscillator1, oscillator2];
    }

    filter.connect(context.destination);
  };
};

export const instruments = [
  {
    name: "Electric Piano",
    make: makePiano
  },
  {
    name: "Bass",
    make: makeBass
  },
  {
    name: "Dark Bass",
    make: makeDarkBass
  },
  {
    name: "Pad",
    make: makePad
  },
  {
    name: "Lead",
    make: makeLead
  },
  {
    name: "Drops",
    make: makeDrops
  },
  {
    name: "Mosquito",
    make: makeMosquito
  },
  {
    name: "Electronic Ghost",
    make: makeElectronicGhost
  }
];

let selectedInstrument = 0;

const context = new AudioContext();

const playNote = note => {
  instruments[selectedInstrument].make(context)(note);
};

const stopNote = note => {
  if (oscillators[note]) {
    oscillators[note].forEach(oscillator => oscillator.stop());
    oscillators[note] = null;
  }
};

const stopAllNotes = () => {
  const keys = Object.keys(oscillators);
  keys.forEach(
    key =>
      oscillators[key] &&
      oscillators[key].forEach(oscillator => oscillator.stop())
  );
  keys.forEach(key => {
    oscillators[key] = null;
  });
};

export const Player = {
  playNote,
  stopNote,
  stopAllNotes,
  selectInstrument: index => (selectedInstrument = index)
};
